/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSavedView
 */
export interface UserSavedView {
    /**
     * 
     * @type {string}
     * @memberof UserSavedView
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserSavedView
     */
    name: string | null;
}

/**
 * Check if a given object implements the UserSavedView interface.
 */
export function instanceOfUserSavedView(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function UserSavedViewFromJSON(json: any): UserSavedView {
    return UserSavedViewFromJSONTyped(json, false);
}

export function UserSavedViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSavedView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function UserSavedViewToJSON(value?: UserSavedView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

